import { Fetcher } from '../../../api/Fetcher';
import { Logger } from '../../../logger/Logger';

export interface FetchSlotsOpenUrlParams {
  JSESSIONID: string;
  baseUrl: string;
  gameID: string;
  signal: AbortSignal;
}

export const fetchSlotsOpenUrl = ({
  baseUrl,
  JSESSIONID,
  gameID,
  signal,
}: FetchSlotsOpenUrlParams): Promise<string | undefined | void> => {
  return Fetcher.fetch(`${baseUrl}/api/ui/SlotLaunch`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
      'Access-Control-Allow-Origin': '*',
    },
    params: {
      JSESSIONID,
      ck: new Date().getTime(),
    },
    body: {
      gameID,
    },
    signal,
    format: 'text',
  })
    .then((response) => {
      if (response === 'Not supported') {
        throw new Error('Not supported');
      }

      const data: ISlotsResponse = JSON.parse(response as string);

      if (data.error !== 0) {
        throw new Error(data.description);
      }
      return data.gameURL;
    })
    .catch((reason) => {
      Logger.logFailure('fetch', {
        place: 'slotsOpenUrlProcessing',
        additional: reason?.message ?? '',
      });
      throw reason;
    });
};

export interface ISlotsResponse {
  error?: number;
  description?: string;
  gameURL?: string;
}
